<div class="container">
  <div class="wrapper">   
		
		<div class="title-container">
			<ion-text class="title ion-text-start">Elige las cuentas que quieras congelar</ion-text>
			<ion-text class="label ion-text-start">
				{{titleLabel}}</ion-text>
		</div>

		<div class="cuentas-obligatorias-container" *ngIf="isAnyObligatoryAccountWithFunds()">
			<app-congelamiento-saldos-cuentas-obligatorias 
				(ccoCheckboxChange)="ccoCheckbox = $event"
				(cdcCheckboxChange)="cdcCheckbox = $event"
				(ccoSelectedAmountChange)="ccoSelectedAmount = $event"
				(cdcSelectedAmountChange)="cdcSelectedAmount = $event"	
			></app-congelamiento-saldos-cuentas-obligatorias>	
		</div>

		<div class="cuentas-voluntarias-container" *ngIf="isAnyVoluntaryAccountWithFunds()">
			<app-congelamiento-saldos-cuentas-voluntarias
				(ccvCheckboxChange)="ccvCheckbox = $event"
				(cavCheckboxChange)="cavCheckbox = $event"
				(isCCVCorrectlySelectedEvent)="ccvCorrectlySelected= $event"
				(isCAVCorrectlySelectedEvent)="cavCorrectlySelected= $event"
				(ccvSelectedAmountChangeEvent)="ccvSelectedAmount = $event"
				(cavSelectedAmountChangeEvent)="cavSelectedAmount = $event"	
				(ccvOutPercentage)="ccvSelectedPercentage = $event"				
				(cavOutPercentage)="cavSelectedPercentage = $event"				
			></app-congelamiento-saldos-cuentas-voluntarias>
			<div class="swipe-instructions">
				<img src="../assets/icons/swipe_right.svg" alt=""/>
				<ion-text class="swipe-text">
					Desliza hacia la derecha para ver todo el contenido
				</ion-text>
			</div>
		</div>

		<div class="saldo-total-ambas-cuentas-container"
		*ngIf="isAnyObligatoryAccountWithFunds() && isAnyVoluntaryAccountWithFunds()"
		>
			<div class="grid-container">
				<ion-grid class="grid">
					<ion-row class="grid-content-total">
						<ion-col  class="left-col" size="7">
								<ion-text class="selected-amount-text">Saldo total a congelar</ion-text></ion-col>
						<ion-col class="right-col">
								<ion-text class="selected-amount-text">{{ numberToChileanCurrency(selectedTotalAmount) }}</ion-text>
						</ion-col>
					</ion-row>
				</ion-grid>
			</div>	
		</div>
		
		<div class="extra-info-container">
			<ion-text class="title ion-text-start">Ten en cuenta que:</ion-text>
			<ul>
				<li> 
					<ion-text class="label">No es posible congelar el saldo de las cuentas: Afiliado Voluntario, 
						APVC - Ahorro Previsional Voluntario Colectivo, Bono de Reconocimiento y Ahorro de Indemnización.
					</ion-text>
				</li>
			</ul>
		</div>

		<div class="action-container">
			<button class="b-btn s-button" (click)="exit()">Salir</button>
			<button class="b-btn p-button" [disabled]="!isAnyAccountCorrectlySelected" (click)="continue()">
				Continuar
				<ion-spinner
					name="crescent"
					slot="end"
					*ngIf="loading; else noLoading"
					color="light"
				></ion-spinner>
				<ng-template #noLoading>
					<ion-icon name="arrow-forward-outline"></ion-icon>
				</ng-template>
			</button>
		</div>
	</div>
</div>